import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE, SEARCH_REQUEST_BYKEYS_FORCE} from '../../../../store/search'
import {SearchEntities} from '../../../../common/enums'
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)

@Component
class TicketMandateOrQuoteSelector extends Vue {
  /**
   *
   */
  dtTemporaryContractors: any[] | null;
  dtShowAllContractor: boolean;
  dtSaveCurrentSelected: any[];

  @Prop({default: () => [], type: [Array]})
  value: number[]
  @Prop({default: () => [], type: [Array]})
  rules: any[]
  @Prop({ default: false, type: [Boolean] })
  disabled: false
  @Prop({ default: false, type: [Boolean] })
  isMandate: false
  @Watch('isMandate')
  mandateChange () {
    this.loadContractor()
  }
  @Prop({ default: () => null, type: [Number] })
  block: number
  @Watch('block')
  blockChange () {
    this.loadContractor()
  }

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetResources: (payload: { entity: SearchEntities[], query?: string, block?: number[] }) => Promise<any[]>;
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetIndependentContractors: (payload: { keys: string[], force?: boolean }) => Promise<any[]>;

  @SearchStore.Getter contractors: any[];
  @SearchStore.Getter caretakers: any[];

  constructor () {
    super()
    this.dtTemporaryContractors = []
    this.dtSaveCurrentSelected = []
    this.dtShowAllContractor = false
  }

  get vModel (): number[] {
    return this.value
  }

  set vModel (value: number[]) {
    value.map(x => {
      if (this.dtSaveCurrentSelected.findIndex(y => y.id === x) === -1) {
        let contractorToAdd = this.dtTemporaryContractors.find(y => y.id === x)
        if (contractorToAdd) {
          this.dtSaveCurrentSelected.push(contractorToAdd)
        }
      }
    })
    this.$emit('input', value)
  }

  get lblSetting () {
    return {
      ...require('@/locales/ticket').default
    }
  }

  get resources () {
    return this.dtSaveCurrentSelected.concat(this.dtTemporaryContractors)
  }

  get coBlock () {
    return this.$route.meta['block_contractor_linked'] && !this.dtShowAllContractor && this.block ? [this.block] : []
  }

  get coEntityType () {
    return this.isMandate ? [SearchEntities.Contractor] : [SearchEntities.IndependentContractor]
  }

  mounted () {
    this.loadContractor()
  }

  handleFilter (key: string) {
    return this.storeGetResources({
      entity: this.coEntityType,
      query: key,
      block: this.coBlock
    }).then(res => {
      this.dtTemporaryContractors = res
      return res
    })
  }

  loadContractor () {
    this.storeGetResources({
      entity: this.coEntityType,
      block: this.coBlock
    }).then(res => {
      this.dtSaveCurrentSelected = []
      this.vModel = []
      this.dtTemporaryContractors = res
    })
  }
}

export default TicketMandateOrQuoteSelector



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-mandate-or-quote-selector/index.ts